import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { $cardBalanceStore, $profileFeatureStore } from '@lib/store';

export const useCardBalance = (cardId: number) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const cardBalanceStore = useUnit($cardBalanceStore.store);

  const [balance, setBalance] = useState<number>();

  useEffect(() => {
    if (cardBalanceStore.data != null) {
      const cardBalance = cardBalanceStore.data.find((a) => a.cardId === cardId);
      if (cardBalance) setBalance(cardBalance.balance);
    }
  }, [cardBalanceStore.data]);

  useEffect(() => {
    setBalance(undefined);
    if (!cardId) return;
    const currentCardPermission = profileFeatureStore.data?.cardFlows.find((x) => x.cardId === cardId);
    if (!currentCardPermission?.viewCardLimit) return;
    $cardBalanceStore.events.getBalance(cardId);
  }, [cardId]);

  return balance;
};
